const base64ToImage = imageData => {
  if (imageData) {
    return "data:image/png;base64," + imageData;
  } else {
    return null;
  }
};

export default base64ToImage;
